// TODO: get all extensions from backend
import { t } from "@i18n";
import { type TranslatedString, untranslated } from "@Helpers/types/i18n";
export const EXCEL_TYPE = ["xls", "xlsx", "csv", "xlsm"];
export const DOC_TYPE = ["doc", "docx", "rtf", "txt", "htm", "html", "sfdt"];
export const DRAWING_TYPE = [
  "dwg",
  "ifc",
  "rvt",
  "rfa",
  "ifczip",
  "step",
  "dwf",
  "dwfx",
  "stp",
  "iges",
  "fbx",
  "prt",
  "pkg",
  "nwd",
  "sldasm",
  "sldprt",
  "ipt",
  "iam",
  "obj",
  "skp",
  "pts",
  "ptx",
  "xyz",
];
export const IMAGE_TYPE = ["jpg", "png"];
export const PDF_TYPE = ["pdf"];
export const containerFileTypes = [
  "IFC",
  "RVT",
  "RFA",
  "NWD",
  "DWG",
  "OBJ",
  "PPTX",
  "PDF",
  "DOC",
  "DOCX",
  "RTF",
  "TXT",
  "XLS",
  "XLSX",
  "XLSM",
  "CSV",
  "JPG",
  "JPEG",
  "PNG",
];
export const BIM_ENGINE = "BIM";
export const CAD_ENGINE = "CAD";
export const PDF_ENGINE = "PDF";
export const SHEET_ENGINE = "Spreadsheet";
export const IMAGE_ENGINE = "Image";
export const DOCUMENT_ENGINE = "Document";
export const PANORAMA_ENGINE = "Panorama";
export const VIDEO_ENGINE = "Video";
export const HTML_ENGINE = "Html";
export const engines = [
  BIM_ENGINE,
  CAD_ENGINE,
  PDF_ENGINE,
  SHEET_ENGINE,
  IMAGE_ENGINE,
  DOCUMENT_ENGINE,
  PANORAMA_ENGINE,
  VIDEO_ENGINE,
  HTML_ENGINE,
];
export const enginesDataSource = [
  { name: BIM_ENGINE, value: BIM_ENGINE },
  { name: CAD_ENGINE, value: CAD_ENGINE },
  { name: PDF_ENGINE, value: PDF_ENGINE },
  { name: SHEET_ENGINE, value: SHEET_ENGINE },
  { name: IMAGE_ENGINE, value: IMAGE_ENGINE },
  { name: DOCUMENT_ENGINE, value: DOCUMENT_ENGINE },
  { name: PANORAMA_ENGINE, value: PANORAMA_ENGINE },
  { name: VIDEO_ENGINE, value: VIDEO_ENGINE },
  { name: HTML_ENGINE, value: HTML_ENGINE },
];

export const userSettingsType = {
  FILE_CALIBRATION: "FILE_CALIBRATION",
};

export const reviewFlowViewType = {
  NORMAL_REVIEWFLOW: "active",
  ARCHIVED_REVIEWFLOW: "archived",
};

export const reviewViewType = {
  ACTIVE_REVIEW: "active",
  ARCHIVED_REVIEW: "archived",
  DELETED_REVIEW: "deleted",
};

export const SUPPORT_PAGE_URL = "https://support.cube.ms/portal/2?createRequest=true&portalId=2&requestTypeId=9";
export const CONVERSION_STATUS_MAPPER = {
  NOT_STARTED: "File conversion has not started",
  NOT_REQUIRED: "",
  IN_PROGRESS: "File conversion is in progress",
  COMPLETED: "File conversion successful",
  ERRORED: "File conversion has failed",
  RETRY: "File conversion is in progress",
};
export const TOAST_TYPE_SUCCESS = "SUCCESS";
export const TOAST_TYPE_NORMAL = "NORMAL";
export const TOAST_TYPE_ERROR = "ERROR";
export const TOAST_TYPE_WARNING = "WARNING";
export const TOAST_TYPE_INFO = "INFO";
export const DELHI_CORDINATES = { lat: 28.6448, lng: 77.216721 };
export const SOMETHING_WENT_WRONG = t("Something went wrong");
export const SIMULATION = "Simulation";
export const GLOBAL = "global";

export const TWO_FA_MODE_EMAIL = "email";
export const TWO_FA_MODE_QR = "qr";

// Need to migrate to db
export const classificationData = [
  { id: "1a", name: "Residential", hasChild: true },
  { id: "2a", name: "Non-Residential ", hasChild: true },
  {
    id: "3a",
    pid: "1a",
    name: "Quarters",
    hasChild: true,
  },
  {
    id: "4a",
    pid: "1a",
    name: "Dormitories",
    hasChild: true,
  },
  {
    id: "6a",
    pid: "1a",
    name: "Hostels",
    hasChild: true,
  },
  {
    id: "7a",
    pid: "1a",
    name: "Guest House",
    hasChild: true,
  },
  {
    id: "8a",
    pid: "1a",
    name: "Hotels",
    hasChild: true,
  },
  {
    id: "9a",
    pid: "2a",
    name: "Education buildings",
    hasChild: true,
  },
  {
    id: "10a",
    pid: "2a",
    name: "Institutional Buildings",
    hasChild: true,
  },
  {
    id: "11a",
    pid: "2a",
    name: "Assembly Buildings",
    hasChild: true,
  },
  {
    id: "12a",
    pid: "2a",
    name: "Business Buildings",
    hasChild: true,
  },
  {
    id: "13a",
    pid: "2a",
    name: "Mercantile buildings",
    hasChild: true,
  },
  {
    id: "14a",
    pid: "2a",
    name: "Industrial  Buildings",
    hasChild: true,
  },
  {
    id: "15a",
    pid: "2a",
    name: "Storage Buildings",
    hasChild: true,
  },
  {
    id: "16a",
    pid: "2a",
    name: "Hazardous Buildings",
    hasChild: true,
  },
  {
    id: "17a",
    pid: "2a",
    name: "Public Infrastructure",
    hasChild: true,
  },
  {
    id: "18a",
    pid: "2a",
    name: "Border Works",
    hasChild: true,
  },
  {
    id: "19a",
    pid: "2a",
    name: "Others",
    hasChild: true,
  },
  { id: "20a", pid: "3a", name: "Type I" },
  { id: "21a", pid: "3a", name: "Type II" },
  { id: "22a", pid: "3a", name: "Type III" },
  { id: "23a", pid: "3a", name: "Type IV" },
  { id: "24a", pid: "3a", name: "Type IV (SPL)" },
  { id: "25a", pid: "3a", name: "Type V-A (D-II)" },
  { id: "26a", pid: "3a", name: "Type V-B (D-I)" },
  { id: "27a", pid: "3a", name: "Type VI-A (C-II)" },
  { id: "28a", pid: "3a", name: "Type VI (C-I)" },
  { id: "29a", pid: "3a", name: "Type VII" },
  { id: "30a", pid: "3a", name: "Type VIII" },
  { id: "31a", pid: "9a", name: "Schools" },
  { id: "32a", pid: "9a", name: "Colleges" },
  { id: "33a", pid: "9a", name: "Training Institute" },
  { id: "34a", pid: "10a", name: "Hospitals" },
  { id: "35a", pid: "10a", name: "Nursing Homes" },
  { id: "36a", pid: "10a", name: "Sanatoria" },
  { id: "37a", pid: "10a", name: "Custodial Institutions" },
  { id: "38a", pid: "10a", name: "Penal & Mental institutions" },
  { id: "39a", pid: "12a", name: "Offices" },
  { id: "40a", pid: "12a", name: "Banks" },
  { id: "41a", pid: "12a", name: "Police Station" },
  { id: "42a", pid: "12a", name: "Laboratories" },
  { id: "43a", pid: "12a", name: "Outpatient Clinics" },
  { id: "44a", pid: "12a", name: "Research Establishment" },
  { id: "45a", pid: "12a", name: "Libraries" },
  { id: "46a", pid: "12a", name: "Test House" },
  { id: "47a", pid: "12a", name: "Electronic Data Processing" },
  { id: "48a", pid: "12a", name: "Information Technology Park" },
  { id: "49a", pid: "12a", name: "Call Centers" },
  { id: "50a", pid: "12a", name: "Telephone Exchange" },
  { id: "51a", pid: "12a", name: "Broad casting station." },
  { id: "52a", pid: "12a", name: "TV Station" },
  { id: "53a", pid: "12a", name: "Air traffic Control tower" },
  { id: "54a", pid: "13a", name: "Shops" },
  { id: "55a", pid: "13a", name: "Stores" },
  { id: "56a", pid: "13a", name: "Underground Shopping Complex" },
  { id: "57a", pid: "13a", name: "Markets" },
  { id: "58a", pid: "14a", name: "Assembly plants" },
  { id: "59a", pid: "14a", name: "Industrial Laboratories" },
  { id: "60a", pid: "14a", name: "Dry Cleaning Plants" },
  { id: "61a", pid: "14a", name: "Power Plants" },
  { id: "62a", pid: "14a", name: "Generating Units" },
  { id: "63a", pid: "14a", name: "Pumping  Station" },
  { id: "64a", pid: "14a", name: "Fumigation Chambers" },
  { id: "65a", pid: "14a", name: "Laundries" },
  { id: "66a", pid: "14a", name: "Gas plants" },
  { id: "67a", pid: "14a", name: "Refineries" },
  { id: "68a", pid: "14a", name: "Dairies" },
  { id: "69a", pid: "14a", name: "Saw Mills" },
  { id: "70a", pid: "15a", name: "Ware houses" },
  { id: "71a", pid: "15a", name: "Cold storage" },
  { id: "72a", pid: "15a", name: "Freight depots" },
  { id: "73a", pid: "15a", name: "Transit sheds" },
  { id: "74a", pid: "15a", name: "Storehouse" },
  { id: "75a", pid: "15a", name: "Truck & Marine terminals" },
  { id: "76a", pid: "15a", name: "Garages" },
  { id: "77a", pid: "15a", name: "Hangers" },
  { id: "78a", pid: "15a", name: "Grain elevators" },
  { id: "79a", pid: "15a", name: "Barns" },
  { id: "80a", pid: "15a", name: "Stables" },
  { id: "81a", pid: "17a", name: "Road" },
  { id: "82a", pid: "17a", name: "Bridge" },
  { id: "83a", pid: "17a", name: "Flyover" },
  { id: "84a", pid: "17a", name: "Tower" },
  { id: "85a", pid: "17a", name: "Treatment Plants" },
  { id: "86a", pid: "17a", name: "Substations" },
  { id: "87a", pid: "17a", name: "Other Works" },
  { id: "88a", pid: "18a", name: "Fencing" },
  { id: "89a", pid: "18a", name: "Lighting" },
  { id: "90a", pid: "18a", name: "Barracks" },
  { id: "91a", pid: "18a", name: "Other Work on Border" },
];

export const PLATFORM = {
  web: "WEB",
  mobile: "MOBILE",
  desktop: "DESKTOP",
};

export const modulesNameSynonymMapper = {
  projects: "Sub-Divisions",
  project: "Sub-Division",
  spaces: "Schemes",
  space: "Scheme",
  spaceName: "Scheme ID",
  projectName: "Sub-Division Name",
  projectId: "Sr.No",
  spaceDescription: "Scheme Name",
};

export const formatBytes = (bytes: number, decimals = 2): TranslatedString => {
  if (bytes === 0) {
    return untranslated("0 Bytes");
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return untranslated(`${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`);
};

/** One question inside a form-template section, as stored on the template document. */
interface FormTemplateQuestion {
  _id: string;
  answer?: { value?: string | string[] | number | boolean | null };
  isVaries?: boolean;
}

/** One section of a form template. */
interface FormTemplateSection {
  questionFields?: FormTemplateQuestion[];
}

/**
 * The templates arrive as `unknown[][]` from the two sidebars that compare them, so each row is
 * narrowed once here — a row that is not a section object is dropped rather than indexed blindly.
 */
const isFormTemplateSection = (value: unknown): value is FormTemplateSection =>
  typeof value === "object" && value !== null && (!("questionFields" in value) || Array.isArray(value.questionFields));

const toFormTemplateSections = (template: unknown): FormTemplateSection[] =>
  Array.isArray(template) ? template.filter(isFormTemplateSection) : [];

// Returns `any` though it always builds a `FormTemplateSection[]`. No consumer relies on the `any`:
// CustomMetadata and AssetSidebar both take the result as `unknown` and narrow it. Fix: type the return
// `FormTemplateSection[]`.
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- return position: callers sit in a ternary whose other arm is possibly-undefined
export const compareFormTemplates = (templates: unknown[][]): any => {
  if (templates.length === 0) return [];
  // Non-empty by the guard above, so the last element is present.
  const lastSelectedNodeTemplate = toFormTemplateSections(templates[templates.length - 1]);
  const uniqueAnsMapper: Record<string, Set<unknown>> = {};

  lastSelectedNodeTemplate.map((section) => {
    section.questionFields?.map((question) => {
      uniqueAnsMapper[question._id] = new Set();
    });
  });
  templates.map((template) => {
    toFormTemplateSections(template).map((section) => {
      section.questionFields?.map((question) => {
        let answer = question.answer?.value || null;
        if (Array.isArray(answer)) {
          if (answer.length === 0) {
            answer = null;
          } else {
            answer = JSON.stringify([...answer].sort((a, b) => a.localeCompare(b)));
          }
        }
        // Seeded lazily: the pre-pass above only covers the LAST template, so a question that exists
        // in an earlier one has no set yet. The compare pass below reads only the last template's
        // questions, so the extra entries are never observed.
        (uniqueAnsMapper[question._id] ??= new Set()).add(answer);
      });
    });
  });

  const comparedTemplate = lastSelectedNodeTemplate.map((section) => {
    const allQuestions = section.questionFields?.map((question) => {
      if ((uniqueAnsMapper[question._id]?.size ?? 0) > 1) {
        question.isVaries = true;
      }
      return question;
    });
    // `questionFields` is optional, so when the section carries none the key has to stay ABSENT
    // rather than be written back as an explicit `undefined`. The map above mutates each question in
    // place and returns those same rows, so skipping a write of nothing changes no output.
    if (allQuestions) {
      section.questionFields = allQuestions;
    }
    return section;
  });

  return comparedTemplate;
};
